import React from 'react';
import {PerforationDivider} from '../../../components/perforation-divider';
import {Account} from '../../../models';
import {PublicReccoSection} from './public-recco-section';
import ExperienceEducation from '../../job-applicant/components/applicant-profile/experience-education-details.component';
import ElevatorPitch from '../../job-applicant/components/elevator-pitch.component';
import {RelevantWork} from '../../job-applicant/components/applicant-profile/relevant-work.component';

type ProfileSectionsProps = {
  account: Account;
};

export const ProfileSections: React.FC<ProfileSectionsProps> = ({account}) => {
  return (
    <section className="grid gap-6 rounded-2xl bg-gray-100 p-6 sm:px-8 md:px-10 lg:grid-cols-[1fr_auto_1.5fr_auto_1fr]">
      <div className="flex flex-col gap-6 max-h-[calc(100vh-220px)] overflow-y-auto">
        <RelevantWork accountId={account.id} />
      </div>
      <div className="hidden lg:block">
        <PerforationDivider className="h-full" />
      </div>
      <div className="flex flex-col gap-6 max-h-[calc(100vh-220px)] overflow-y-auto">
        <ElevatorPitch account={account} />
        <ExperienceEducation account={account} />
      </div>
      <div className="hidden lg:block">
        <PerforationDivider className="h-full" dense />
      </div>
      <div className="flex flex-col gap-6 max-h-[calc(100vh-220px)] overflow-y-auto">
        <PublicReccoSection accountId={account.id} />
      </div>
    </section>
  );
};
